module.exports = __webpack_public_path__ + "static/media/8OLA19.9f3898a2.jpg";